import { Injectable, ViewChild } from '@angular/core';
import { Settings } from './settings';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { DAO } from '../modal/DAO';
import { AppComponent } from '../app.component';
import { Callbacks, data, readyException } from 'jquery';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { of, throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

declare var $: any;

@Injectable()
export class CommonService {
  public setting: Settings = new Settings();

  // public appComponent: AppComponent = new AppComponent(null,null);  

  constructor(public http: HttpClient, public confirmService: ConfirmationService, public dao: DAO, public authenticationService: AuthenticationService) {

  }

  // getBearerToken should return an Observable<HttpHeaders>
  // getBearerToken(): Observable<HttpHeaders> {
  //   let headers = new HttpHeaders();
  //   let payload = { "urlData": [environment.AppName, environment.CompanyCode] };

  //   if (payload.urlData) {
  //     payload.urlData = payload.urlData.map(element => encodeURIComponent(decodeURIComponent(element)));
  //   }


  //   let settingDetails;
  //   let functionality = "GetBearerTokenForAPIAuthentication";
  //   let component = "BearerToken";

  //   // Get the service payload details
  //   settingDetails = this.setting.getServicePayloadDetails(component, functionality, payload.urlData || payload);

  //   // return this.http.get<any>(settingDetails.endPointInfo.endPointUrl, { observe: 'response' })
  //   // .pipe(
  //   //   map((response: HttpResponse<any>) => {
  //   //     const authtoken = response.body;
  //   //     if (authtoken?.access_token) {
  //   //       headers = headers.append('Authorization', `${authtoken.token_type} ${authtoken.access_token}`);
  //   //     }
  //   //     return headers;
  //   //   }),
  //   //   catchError((err) => {
  //   //     return this.openErrorPopup(err, settingDetails.endPointInfo.endPointUrl, '', functionality) ? Observable.of(err) :  of(null);
  //   //   })
  //   // );
  // }

  // Get the token from localStorage and return it as an Observable<HttpHeaders>
  getBearerToken(): Observable<HttpHeaders> {
    let headers = new HttpHeaders();
    var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
    if (loginDetails?.accessToken) {
          headers = headers.set('Authorization', `Bearer ${loginDetails?.accessToken}`);
        }
    return of(headers);
  }

  get(componentName: string, functionality: string, payload?: any): Observable<any> {
    if (payload?.urlData) {
      payload.urlData = payload.urlData.map((element) => encodeURIComponent(decodeURIComponent(element)));
    }

    this.triggerLoader ? this.triggerLoader('show') : '';

    // Get payload details from setting file
    const settingDetails = this.setting.getServicePayloadDetails(componentName, functionality, payload?.urlData || payload);

    // Chain the token fetching with the actual HTTP call
    return this.getBearerToken().pipe(
      switchMap((headerValues) => {
        return this.http.get<any>(settingDetails.endPointInfo.endPointUrl, { observe: 'response', headers: headerValues, }).pipe(
          map((response: HttpResponse<any>) =>
            this.openErrorPopup(response, settingDetails.endPointInfo.endPointUrl, '', functionality) ? response.body : of(null)),
          catchError((err) => {
            return this.openErrorPopup(err, settingDetails.endPointInfo.endPointUrl, '', functionality) ? of(err) : throwError(err);
          })
        )
      })
    );
  }

  getStringResponse(componentName: string, functionality: string, payload?: any): Observable<any> {
    //=====show spinner==========

    // =============get payload details from setting file========
    const settingDetails = this.setting.getServicePayloadDetails(componentName, functionality,  payload?.urlData );

    return this.getBearerToken().pipe(
      switchMap((headerValues) => {
        return this.http.get<any>(settingDetails.endPointInfo.endPointUrl, { headers: headerValues }).pipe(
          map((response: any) => response), // Return the full response
          catchError((err) => {
            // Handle your error here
            // Hide the spinner or any other UI elements
            return of(err); // Use `of` to return the error as an observable
          })
        );
      })
    );
  }
  post(componentName: string, functionality: string, payload?: any): Observable<any> {
    if (payload?.urlData) {
      payload.urlData.forEach((element, index) => {
        payload.urlData[index] = encodeURIComponent(decodeURIComponent(element));
      });
    }

    // Show spinner if applicable
    this.triggerLoader ? this.triggerLoader('show') : '';

    // Get payload details from settings file
    const settingDetails = this.setting.getServicePayloadDetails(componentName, functionality, payload?.urlData);

    return this.getBearerToken().pipe(
      switchMap((headerValues) => {
        return this.http.post<any>(
          settingDetails.endPointInfo.endPointUrl,
          payload?.payloadData,
          { observe: 'response', headers: headerValues }
        ).pipe(
          map((response: HttpResponse<any>) => {
            return this.openErrorPopup(response, settingDetails.endPointInfo.endPointUrl, payload?.payloadData, functionality) ? response.body :  of(null);
          }),
          catchError((err) => {
            return this.openErrorPopup(err, settingDetails.endPointInfo.endPointUrl, payload?.payloadData, functionality) ? of(err) :  of(null);
          })
        );
      })
    );
  }

  put(componentName: string, functionality: string, payload?: any, body?: any): Observable<any> {
    if (payload?.urlData) {
      payload.urlData.forEach((element, index) => {
        element = encodeURIComponent(decodeURIComponent(element));
        payload.urlData[index] = element.replace(/[!'()*.-_~]/g, escape);
      });
    }

    // Show spinner if applicable
    this.triggerLoader ? this.triggerLoader('show') : '';

    // Get payload details from the settings file
    const settingDetails = this.setting.getServicePayloadDetails(componentName, functionality, payload?.urlData);

    // Get Bearer Token and make the PUT request
    return this.getBearerToken().pipe(
      switchMap((headerValues) => {
        return this.http.put<any>(
          settingDetails.endPointInfo.endPointUrl,
          body || payload?.payloadData, // Pass the body if provided, or use payloadData
          { observe: 'response', headers: headerValues }).pipe( map((response: HttpResponse<any>) => {
            return this.openErrorPopup(response, settingDetails.endPointInfo.endPointUrl, payload?.payloadData, functionality) ? response.body :  of(null);
          }),
          catchError((err) => {
            return this.openErrorPopup(err, settingDetails.endPointInfo.endPointUrl, payload?.payloadData, functionality) ? of(err) :  of(null);
          })
        );
      })
    );
  }

  async openLink(linkName, insuredName: string = '', policyNo: string = '', userName: string = '') {
    let settingDetails = this.setting.getServicePayloadDetails('Link', linkName, [policyNo]);
    if (linkName == "agentPortual") {
      await this.UrlExists(settingDetails.endPointInfo.endPointUrl, userName, insuredName, policyNo);
    }
    else {
      window.open(settingDetails.endPointInfo.endPointUrl, "_blank");
    }
  }
  async UrlExists(url, userName, insuredName, policyNo) {
    var _this = this;
    $.ajax({
      url: url,
      'cache': false,
      'dataType': "jsonp",
      "async": false,
      "crossDomain": true,
      "method": "POST",
      "headers": {
        "accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        'access-control-allow-headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token'
      }
    })
      .fail(async function (jqXHR) {
        if (jqXHR.status != 200) {
          let payload: any = {};
          payload.userName = userName;
          payload.insuredName = insuredName;
          payload.url = url;
          let postpayload = { "urlData": [], "payloadData": payload };
          //  let payload = { "urlData": [userName, insuredName, url]}
          await (await _this.post('policies', 'ViewPolicyDocumentError', postpayload)).toPromise();
          _this.dao.showErrorPopup = true;
        }
        else {
          window.open(url, "_blank");
        }
      });
  }
  openErrorPopup(response, endPointUrl, payloadData, functionality) {
    this.triggerLoader ? this.triggerLoader('hide') : '';
    if (response?.status != 200) {
      this.openError(response, endPointUrl, payloadData, functionality);
      return false;
    }
    return true;
  }
  triggerLoader(type) {
    if (document.getElementById("loaderForServiceCall")) {
      if (type === 'hide') {
        document.getElementById("loaderForServiceCall").style.display = 'none';
        document.body.style.opacity = "1";
        document.body.style.pointerEvents = "auto";
        document.body.style.background = "none";
        // document.body.className.('pointerNone');
        document.getElementById("body").className = "";
      } else {
        document.getElementById("loaderForServiceCall").style.display = 'block';
        document.body.style.opacity = "1";
        document.body.style.pointerEvents = "none";
        document.body.style.background = "rgba(51,51,51,0.1)";
        document.getElementById("body").className = "pointerNone";
      }
    }
  }
  async openError(response, endPointUrl, payload, functionality) {
    var element = document.getElementById("GettingID");
    if (element != undefined && element != null) {
      element.classList.remove("calculateLbl");
    }
    var updateelement = document.getElementById("UpdateID");
    if (updateelement != undefined && updateelement != null) {
      updateelement.classList.remove("calculateLbl");
    }
    if (functionality != 'PostUserActivity') {
      let userData: any = {};
      userData.Email = this.dao?.loginUserDetail?.email ? this.dao?.loginUserDetail?.email : "";
      userData.AgencyCode = this.dao?.agencyCode;
      userData.PolicyNumber = this.dao?.policyNumber;
      userData.InsuredName = this.dao?.insuredName
      userData.ProgressToPage = window.localStorage.getItem("policyType") ? window.localStorage.getItem("policyType") : "";
      let payloadDetail: any = {};
      payloadDetail.endPointURL = endPointUrl;
      payloadDetail.payload = payload;
      payloadDetail.response = response;
      userData.Payload = JSON.stringify(payloadDetail);
      userData.TransactionStatus = "Error";
      userData.RateOnly = false;
      userData.ActionType = "Error";
      if (userData.Email != undefined && userData.Email != null && userData.Email != '' && userData.ProgressToPage != undefined && userData.ProgressToPage != null && userData.ProgressToPage != '') {
        let postpayload = { "urlData": [], "payloadData": userData };
        this.post('Common', 'PostUserActivity', postpayload).toPromise();
      }
    }
    if (functionality == 'RequestEvidence' || functionality == 'SubmitPremium' || functionality == 'submitCancelDetail') {
      this.dao.showErrorPopup = true;
    }
  }

}



